import { Injectable } from '@angular/core';
import { logEvent } from 'firebase/analytics';
import { getFirebaseWebAnalytics } from 'src/app/firebase/firebase-core';
import { Language } from '../thi-translations';
import { ThiCampaignAttributionService } from './thi-campaign-attribution.service';

@Injectable({ providedIn: 'root' })
export class ThiLandingAnalyticsService {
  constructor(private readonly attribution: ThiCampaignAttributionService) {}

  private baseParams(lang: Language): Record<string, string | number> {
    const stored = this.attribution.getStored();
    const params: Record<string, string | number> = { lang };
    if (stored?.utm_source) {
      params['utm_source'] = stored.utm_source;
    }
    if (stored?.utm_campaign) {
      params['utm_campaign'] = stored.utm_campaign;
    }
    if (stored?.source) {
      params['registration_source'] = stored.source;
    }
    return params;
  }

  private emit(name: string, params?: Record<string, string | number>): void {
    const analytics = getFirebaseWebAnalytics();
    if (!analytics) {
      return;
    }
    try {
      logEvent(analytics, name, params);
    } catch {
      /* blocked or unavailable */
    }
  }

  landingPageView(lang: Language): void {
    this.emit('landing_page_view', {
      ...this.baseParams(lang),
      page: 'campaign_landing',
    });
  }

  startFreeClick(lang: Language, section: string, planId?: number): void {
    const p: Record<string, string | number> = {
      ...this.baseParams(lang),
      section,
    };
    if (planId != null) {
      p['plan_id'] = planId;
    }
    this.emit('start_free_click', p);
  }

  watchDemoClick(lang: Language, section: string): void {
    this.emit('watch_demo_click', { ...this.baseParams(lang), section });
  }

  pricingView(lang: Language): void {
    this.emit('pricing_view', { ...this.baseParams(lang) });
  }

  packageSelected(lang: Language, planId: number, section = 'pricing'): void {
    this.emit('package_selected', {
      ...this.baseParams(lang),
      plan_id: planId,
      section,
    });
  }

  registrationStarted(lang: Language): void {
    this.emit('registration_started', {
      ...this.baseParams(lang),
      source: 'campaign_landing',
    });
  }

  registrationCompleted(lang: Language): void {
    this.emit('registration_completed', {
      ...this.baseParams(lang),
      source: 'campaign_landing',
    });
  }
}
